"use client";

import { Switch as SwitchPrimitive } from "@base-ui/react/switch";

import { cn } from "@/lib/utils";

function Switch({
  className,
  size = "default",
  loading = false,
  loadingIndicatorClassName,
  disabled,
  ...props
}: SwitchPrimitive.Root.Props & {
  size?: "sm" | "default";
  loading?: boolean;
  loadingIndicatorClassName?: string;
}) {
  return (
    <SwitchPrimitive.Root
      aria-busy={loading || undefined}
      className={cn(
        "peer group/switch relative inline-flex shrink-0 items-center rounded-full border border-foreground/10 outline-none transition-all after:absolute after:-inset-x-3 after:-inset-y-2 focus-visible:border-ring focus-visible:ring-3 focus-visible:ring-ring/50 aria-invalid:border-destructive aria-invalid:ring-3 aria-invalid:ring-destructive/20 data-[size=default]:h-[18.4px] data-[size=sm]:h-[14px] data-[size=default]:w-[32px] data-[size=sm]:w-[24px] data-disabled:cursor-not-allowed data-checked:bg-primary data-unchecked:bg-input data-disabled:opacity-50 dark:border-transparent dark:data-unchecked:bg-input/80 dark:aria-invalid:border-destructive/50 dark:aria-invalid:ring-destructive/40",
        className
      )}
      data-loading={loading || undefined}
      data-size={size}
      data-slot="switch"
      disabled={disabled || loading}
      {...props}
    >
      <SwitchPrimitive.Thumb
        className={cn(
          "pointer-events-none block rounded-full bg-background ring-0 transition-transform group-data-[size=default]/switch:size-4 group-data-[size=sm]/switch:size-3 group-data-[size=default]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=default]/switch:data-unchecked:translate-x-0 group-data-[size=sm]/switch:data-checked:translate-x-[calc(100%-2px)] group-data-[size=sm]/switch:data-unchecked:translate-x-0 dark:data-checked:bg-primary-foreground dark:data-unchecked:bg-foreground",
          loading && "opacity-0"
        )}
        data-slot="switch-thumb"
      />
      {loading && (
        <span
          aria-hidden="true"
          className="pointer-events-none absolute inset-0 flex items-center justify-center"
        >
          <span
            className={cn(
              "animate-spin rounded-full border-2 border-muted-foreground border-t-transparent group-data-[size=default]/switch:size-3 group-data-[size=sm]/switch:size-2.5",
              loadingIndicatorClassName
            )}
          />
        </span>
      )}
    </SwitchPrimitive.Root>
  );
}

export { Switch };
